import { BrandKit } from '@goldcast/api/backend';

import { BrandKitState } from './types';

const mutations = {
  setBrandKits(state: BrandKitState, brandKits: BrandKit[]) {
    state.brandKits = brandKits;
  },
  setSelectedBrandKit(state: BrandKitState, brandKit: BrandKit | null) {
    state.selectedBrandKit = brandKit;
  },
  setIsLoading(state: BrandKitState, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setIsLoaded(state: BrandKitState, isLoaded: boolean) {
    state.isLoaded = isLoaded;
  },
  setBrandKitsLoaded(state: BrandKitState, isLoaded: boolean) {
    state.isLoaded = isLoaded;
  }
};

export default mutations;
